<template>
  <div class="flex-col">
    <div class="filter-container">
      <button @click="toggleFilter()">
        <i class="material-icons">filter_list</i>
        <span>{{ "filter.title.filter" | translate }}</span>
      </button>
      <slideup-mobile :is-open="isFilterOpen">
        <filter-mobile @close="toggleFilter()" @apply="applyClicked()" />
      </slideup-mobile>
      <div class="overlay" :class="{ visible: isFilterOpen }"></div>
    </div>

    <div class="main">
      <div class="categories">
        <div
          class="category-container"
          v-for="(subNav, i) in subNavs"
          :key="i"
          @click="onSubNavClick(subNav)"
          :class="{ selected: isSelectedSubNav(subNav) }"
        >
          <span class="top-category">
            {{ `filter.type.${subNav}` | translate | capitalize }}
            <i class="material-icons">expand_more</i>
          </span>
          <div class="sub-category" :class="{ open: isSelectedSubNav(subNav) }">
            <span>Clothing type</span>
            <span>Clothing type</span>
          </div>
        </div>
      </div>
      <gyra-spinner v-if="isLoading" />
      <div v-else class="products">
        <div v-if="hasProducts" class="content-grid">
          <product-card
            v-for="(product, j) in products"
            :product="product"
            :key="j"
            @card-clicked="visitProductPage"
          />
        </div>
        <div v-else class="nothing-found">
          {{ "filter.messages.no_results" | translate }}
        </div>
        <button
          ref="loader"
          class="bottom-loader salmon"
          @click="loadMoreItems()"
        >
          {{ "bottom_loader.load_more" | translate }}
        </button>
      </div>
    </div>
    <button @click="topFunction" class="scroll-btn" id="scroll">
      <i class="material-icons">keyboard_arrow_up</i>
    </button>
  </div>
</template>

<script>
import ProductCard from "./product-card";
import { mapGetters, mapMutations } from "vuex";
import GyraSpinner from "../atoms/gyra-spinner";
import { errorHandling } from "../../mixins";
import { filterMixin } from "../../mixins/filters/filterMixin";
import SlideupMobile from "./slideup-mobile";
import FilterMobile from "../organisms/filter-mobile";
import { productTypeNavigation } from "../../mixins/navigation/productTypeNavigation";
import { getPossibleFilterValues } from "../../services/api";
import { filterModelMixin } from "../../mixins/filters/filterModelMixin";

export default {
  name: "product-grid",
  components: {
    FilterMobile,
    SlideupMobile,
    GyraSpinner,
    ProductCard
  },
  mixins: [errorHandling, filterMixin, productTypeNavigation, filterModelMixin],
  props: {
    categoryProp: String,
    onSaleProp: Boolean,
    sustainableProp: Boolean,
    storeProp: Array
  },
  data() {
    return {
      isLoading: false,
      isFilterOpen: false,
      subNavs: this.subNavsProp
    };
  },
  methods: {
    initFilters() {
      if (this.$route.params.sex) {
        this.setFilterFieldByKeyValue({
          key: "sex",
          value: this.$route.params.sex
        });
      }
      if (this.categoryProp) {
        this.setFilterFieldByKeyValue({
          key: "category",
          value: this.categoryProp
        });
      }
      if (this.sustainableProp) {
        this.setFilterFieldByKeyValue({
          key: "sustainable",
          value: this.sustainableProp
        });
      }
      if (this.onSaleProp) {
        this.setFilterFieldByKeyValue({
          key: "onSale",
          value: this.onSaleProp
        });
      }
      if (this.storeProp) {
        this.setFilterFieldByKeyValue({
          key: "store",
          value: this.storeProp
        });
      }
    },
    async loadFilterResults() {
      this.isLoading = true;
      const products = await this.applyFilters();
      if (products) {
        this.setProducts(products);
      }
      this.isLoading = false;
    },
    async onFilterChanged() {
      await this.loadFilterResults();
      await this.setSelectOptions();
    },
    async loadMoreItems() {
      const productsToAdd = await this.applyFilters();
      if (productsToAdd) {
        this.addProducts(productsToAdd);
      }
    },
    visitProductPage(product) {
      this.$router.push({
        name: "ProductPage",
        params: {
          name: product.name,
          id: product._id,
          sex: this.$route.params.sex
        }
      });
    },
    toggleFilter() {
      this.isFilterOpen = !this.isFilterOpen;
    },
    applyClicked() {
      this.toggleFilter();
      this.loadFilterResults();
    },
    async getSubNavs() {
      let query = {
        sex: this.chosenSex
      };
      if (this.category) {
        query = { ...query, category: this.category };
      }

      const response = await getPossibleFilterValues("type", query);
      if (response.status === 200) {
        this.subNavs = response.data;
      } else {
        this.handleHttpError(response);
      }
    },
    onSubNavClick(subNav) {
      this.resetCommons();
      this.setSubNavItemWithFilter(subNav);
      this.onFilterChanged();
      this.subCatOpen = !this.subCatOpen;
    },
    isSelectedSubNav(subNav) {
      return this.getSubNavItem === subNav;
    },
    navigateToMap() {
      this.$router.push({ name: "ProductMap" });
    },
    onSearchStringInput() {
      setTimeout(() => {
        this.loadFilterResults();
      }, 500);
    },
    ...mapMutations({
      addFilterOptions: "filters/addSelectOptions",
      toggleIsFullscreen: "globals/toggleIsFullscreen",
      resetFilters: "filters/resetSelections",
      resetCommons: "filters/resetCommons",
      setFilterFieldByKeyValue: "filters/setFieldByKeyValue",
      setProducts: "overview/setProducts",
      addProducts: "overview/addProducts"
    }),
    topFunction() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  },
  computed: {
    hasProducts() {
      return this.products && this.products.length > 0;
    },
    translationSubNav() {
      return this.getSubNavItem
        ? `filter.type.${this.getSubNavItem}`
        : "filter.title.overview";
    },
    chosenSex() {
      return this.$route.params.sex;
    },
    ...mapGetters({
      products: "overview/getProducts",
      selects: "filters/getSelects"
    })
  },
  async beforeMount() {
    this.initFilters();
    // await this.loadFilterResults();
    if (!this.products || this.products.length === 0 || this.storeProp) {
      await this.loadFilterResults();
    }
    await this.setSelectOptions();
  },
  async mounted() {
    await this.getSubNavs();

    window.onscroll = function() {
      if (
        document.body.scrollTop > 20 ||
        document.documentElement.scrollTop > 20
      ) {
        if (document.getElementById("scroll"))
          document.getElementById("scroll").style.display = "flex";
      } else {
        if (document.getElementById("scroll"))
          document.getElementById("scroll").style.display = "none";
      }
    };
  },
  watch: {
    $route(to) {
      if (to.name !== "ProductPage") {
        this.resetFilters();
        this.setSelectOptions();
      }
      this.loadFilterResults();
      this.getSubNavs();
    },
    products() {
      if (!this.products) {
        this.loadFilterResults();
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";
.filter-container {
  margin-bottom: $m-m;
  overflow: auto;
  button {
    float: right;
    padding: 0.25rem;
    display: flex;
    align-items: center;
    box-shadow: none;

    span {
      font-size: $font-sm;
      margin-left: 0.5rem;
    }
  }

  .icon-container {
    margin-top: 17px;
    width: 34px;
    height: 34px;
    border-radius: 12px;
    background-color: $gyra-grey-dark;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.filter-toggle {
  cursor: pointer;
  font-size: 34px;
  color: white;
}

h3 {
  font-size: 24px;
  font-weight: bold;
  @media (min-width: 800px) {
    font-size: 32px;
  }
}

.products {
  width: 100%;
}

.content-grid {
  display: flex;
  flex-wrap: wrap;

  .product-card {
    width: 50%;
    margin-bottom: 1.5rem;
    padding: 0.5rem;

    @media (min-width: $breakpoint-md) {
      width: 50%;
    }

    @media (min-width: $breakpoint-lg) {
      width: 33.3%;
    }

    @media (min-width: $breakpoint-xl) {
      width: 25%;
    }
  }
}

.nothing-found {
  display: flex;
  justify-content: center;
  margin-top: 60px;
  font-weight: 400;
  font-size: 24px;
  text-align: center;
}

.apply-button {
  display: flex;
  align-self: center;
  width: 50%;
  border: 1px solid $gyra-salmon;
  border-radius: 10px;
  margin-top: 10px;
  height: 40px;
  align-items: center;
  justify-content: center;
  font-size: 1em;
  color: $gyra-salmon;
  cursor: pointer;
}

.main {
  display: flex;
  flex-direction: row;
}

.categories {
  height: auto;
  flex-direction: column;
  margin-right: 4rem;
  display: none;

  @media (min-width: $breakpoint-md) {
    display: flex;
  }

  .category-container {
    width: 10rem;
    margin-bottom: 0.5rem;
    transition: all 0.3s ease-in-out;
    padding-bottom: 0.25rem;
    cursor: pointer;
    position: relative;
    display: flex;
    flex-direction: column;

    &::after {
      content: "";
      height: 2px;
      width: 100%;
      background-color: $brand-gray-light;
      display: block;
      position: absolute;
      top: 2.5rem;
    }

    span {
      padding: 0.5rem 0;
    }

    .sub-category {
      height: 0;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      transition: all 0.3s ease-in-out;

      &.open {
        height: 100%;
        margin-top: 1rem;
      }

      span {
        margin-left: 1.25rem;
        border-bottom: 1px solid $brand-gray-light;
        color: $brand-gray-medium;
        transition: all 0.3s ease-in-out;

        &:hover {
          transform: translate(1rem, 0px);
          font-weight: 700;
        }
      }
    }

    .top-category {
      transition: all 0.3s ease-in-out;
      font-weight: 500;
      position: relative;
      display: flex;
      justify-content: space-between;
    }

    .material-icons {
      transition: all 0.3s ease-in-out;
    }

    &.selected {
      .top-category {
        font-weight: 700;

        &::after {
          content: "";
          height: 2px;
          background-color: $brand-black;
          position: absolute;
          bottom: 0;
          width: 100%;
          left: 0;
        }

        .material-icons {
          transform: rotate(180deg);
        }
      }

      &:hover {
        .top-category {
          transform: none;
        }
      }
    }

    &:hover {
      .top-category {
        transform: translate(1rem, 0px);
        font-weight: 700;
      }
    }
  }
}

.overlay {
  position: fixed;
  opacity: 0;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: $brand-gray-medium;
  z-index: 20;
  transition: all 0.3s ease-in-out;
  pointer-events: none;

  &.visible {
    opacity: 0.5;
  }
}

.bottom-loader {
  box-shadow: none;
  margin: 2.5rem 0;
  width: 100%;
}

.scroll-btn {
  display: none;
  position: fixed;
  bottom: 1rem;
  right: 1rem;
  z-index: 99;
  cursor: pointer;
  border-radius: 4px;
  width: 2.5rem;
  height: 2.5rem;
  padding: 0.5rem;
  justify-content: center;
  align-items: center;
  border-radius: 2rem;
  background-color: $brand-black;
  color: $brand-white;

  @media (min-width: $breakpoint-sm) {
    bottom: 2rem;
    right: 2rem;
  }

  .material-icons {
    font-size: $font-l;
  }
}
</style>

<style lang="scss">
@import "~@/styles/global.scss";
.filter .vs__dropdown-toggle {
  border-radius: 0;
  border-color: $brand-gray-medium;

  input {
    font-size: $font-sm;
  }
}
.filter .vs__selected-options {
  width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.filter .vs__dropdown-menu {
  min-width: fit-content;
}
</style>
